/**
 *  Module for obtain custom digital data objects to customer.
 */

const DigitalData = function(app) {
  const configure = app.configure;
  const tools = require('./tools')(app);
  const getQuantity = () => configure.run('getQuantity');
  const configureLoaded = () => ({
    event: { eventInfo: {
      eventName: 'configureLoaded' + app.analytics.incrementalNumber//static value
    }},
    page: {
      pageName: tools.getPageName(),
      pageLocale: app.product.locale, //set to locale of website - us, ca, etc.
      pageType: 'product', //static
      pageRedirected: '', //leave empty
      pageJSErrorCount: '', //leave empty
      pageHierarchy: 'cyo', //static
      pageLevel1: 'cyo', //static
      pageLevel2: 'cyo', //static
      pageLevel3: 'cyo', //static
      pageLevel4: 'cyo', //static
      pageProductViewType: 'full', //static
      pageGender: '', //leave empty
      pdpTemplate: 'cyo' //static
    },
    product: {
      item: [
        //item 1//
        {
          productWebCategory: 'cyo', //static
          productAddedFrom: 'pdp', //static
          productCurrency: tools.getCurrency(), //based on location
          productID: tools.getStyleId(), //Master ID or parent – may be same as SKU
          productName: tools.getProductName(), //the name of the product added to the cart
          productPrice: tools.getPrice().toString(), //the price of the product added to the cart
          productPriceType: '', //leave empty
          productQuantity: getQuantity().toString(), //how many of this product are added to the cart
          productStockMessage: '', //leave empty
          productSKU: tools.getStyleId() //the product SKU
        }
      ]
    }
  });

  const recipeChanged = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'recipeChanged' + app.analytics.incrementalNumber//static value
    }},

    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    }
  });
  const attributeOpened = (recipeId, data) => ({
    event: { eventInfo: {
      eventName: 'attributeOpened' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId, //the product Recipe ID
        productCYOAttribute: data.name //CYO attribute associated with this event
      }
    }
  });

  const addToCart = (recipeId, data) => ({
    event: { eventInfo: {
      eventName: 'addToCart' + app.analytics.incrementalNumber//static value
    }},
    page: {
      pageName: tools.getPageName(),
      pdpTemplate: 'cyo' //static value
    },
    product: {
      item:
      {
        productWebCategory: 'cyo', //static
        productAddedFrom: 'pdp', //static
        productCurrency: tools.getCurrency(), //based on location
        productID: tools.getStyleId(), //Master ID or parent – may be same as SKU
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productPriceType: '', //leave empty
        productQuantity: getQuantity().toString(), //how many of this product are added to the cart
        productStockMessage: '', //leave empty
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: data.recipe.id.toString() //the product Recipe ID
      }
    }
  });

  const editCart = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'editCart' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    }
  });

  const addToCatalog = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'saveToCatalog' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    }
  });

  const shareEmail = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'socialShare' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    },
    attributes: {
      socialShareType: 'email' //static value
    }
  });

  const shareFacebook = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'socialShare' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    },
    attributes: {
      socialShareType: 'facebook' //static value
    }
  });

  const shareTwitter = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'socialShare' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    },
    attributes: {
      socialShareType: 'twitter' //static value
    }
  });
  const sharePinterest = (recipeId) => ({
    event: { eventInfo: {
      eventName: 'socialShare' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    },
    attributes: {
      socialShareType: 'pinterest' //static value
    }
  });

  const print = recipeId => ({
    event: { eventInfo: {
      eventName: 'printCYO' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    }
  });
  const startOver = recipeId => ({
    event: { eventInfo: {
      eventName: 'startOver' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    }
  });
  const recipeCatalogClicked = recipeId => ({
    event: { eventInfo: {
      eventName: 'enterViaCatalog' + app.analytics.incrementalNumber//static value
    }},
    page: { pageName: tools.getPageName() },
    product: {
      item:
      {
        productCurrency: tools.getCurrency(), //based on location
        productName: tools.getProductName(), //the name of the product added to the cart
        productPrice: tools.getPrice().toString(), //the price of the product added to the cart
        productSKU: tools.getStyleId(), //the product SKU
        productRecipeID: recipeId //the product Recipe ID
      }
    }
  });
  return {
    addToCart,
    addToCatalog,
    attributeOpened,
    configureLoaded,
    editCart,
    print,
    recipeCatalogClicked,
    recipeChanged,
    shareEmail,
    shareFacebook,
    sharePinterest,
    shareTwitter,
    startOver
  };
};

module.exports = DigitalData;
